const KEY_DEVICE_ID = 'kdj_deid';
// const KEY_KID_ID = 'kdj_kiid';
// const KEY_KID_AGE = 'kdj_kia';
const KEY_USER_ID = 'kdj_uid';
const KEY_KID_USER_SUBSCRIBED = 'kdj_us';
const KEY_KID_COUNTRY_CODE = 'kdj_cc';
const KEY_KID_LANG_CODE = 'kdj_lc';

// const unlockAllContent = process.env.VUE_APP_UNLOCK_ALL_CONTENT === 'true';

export default {
  getDeviceId() {
    return localStorage.getItem(KEY_DEVICE_ID) || null;
  },
  // getKidId() {
  //   return localStorage.getItem(KEY_KID_ID) || null;
  // },
  // getKidAge() {
  //   const age = localStorage.getItem(KEY_KID_AGE) || null;
  //   return age ? parseInt(age, 10) || null : null;
  // },
  // getUserId() {
  //   return localStorage.getItem(KEY_USER_ID) || null;
  // },
  imageDeviceType() {
    const windowWidth = window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth;
    let imageType;

    switch (true) {
      case (windowWidth <= 350) :
        imageType = 'phone-s';
        break;
      case (windowWidth <= 500):
        imageType = 'phone-l';
        break;
      case (windowWidth <= 780):
        imageType = 'tablet-s';
        break;
      default:
        imageType = 'tablet-l';
        break;
    };
    return imageType;
  },
  // isUserSubscribed() {
  //   const isUserSubscribed = localStorage.getItem(KEY_KID_USER_SUBSCRIBED) || null;
  //   return unlockAllContent || isUserSubscribed === 'true';
  // },
  setDeviceData(bootResult) {
    localStorage.setItem(KEY_DEVICE_ID, bootResult.deviceId);
    localStorage.setItem(KEY_KID_USER_SUBSCRIBED, bootResult.isSubscribed.toString());

    // if (bootResult.kids && bootResult.kids.length > 0) {
    //   localStorage.setItem(KEY_KID_ID, bootResult.kids[0].id);
    //   localStorage.setItem(KEY_KID_AGE, bootResult.kids[0].age.toString());
    // }
    if (bootResult.user && bootResult.user.id && bootResult.user.id !== '' && bootResult.user.id !== '0') {
      localStorage.setItem(KEY_USER_ID, bootResult.user.id);
    }
  },
  getCountryCode() {
    return localStorage.getItem(KEY_KID_COUNTRY_CODE) || 'US';
  },
  setCountryCode(countryCode) {
    if (countryCode) {
      localStorage.setItem(KEY_KID_COUNTRY_CODE, countryCode);
    } else {
      localStorage.removeItem(KEY_KID_COUNTRY_CODE);
    }
  },
  getLanguageCode() {
     return localStorage.getItem(KEY_KID_LANG_CODE) || 'en';
  },
  setLanguageCode(languageCode) {
    if (languageCode) {
      localStorage.setItem(KEY_KID_LANG_CODE, languageCode);
    } else {
      localStorage.removeItem(languageCode);
    }
  },
};
